import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const OptionContent = ({ title, description, className }) => {
  return (
    <p className={cn(styles.root, className)}>
      {title && <span className={styles.accent}>{title}</span>}
      {description}
    </p>
  );
};

export default OptionContent;
